export default __webpack_public_path__ + "static/media/applewatch6-bg.a00e2263.webp";